import { PaymentsModule } from './PaymentsModule';

export const PaymentsVerifiedCzech = () => {
  return <PaymentsModule flavor={'VerifiedCzech'} />;
};
